import { Controller } from "@hotwired/stimulus";

// « Reçu de » of the bursar's « Une autre recette » (owner's decision of
// 29/10/2026): a person or an organisation is typed freely; a parent or a
// student of the school is searched, and picking one fills the name, the
// phone and who they are. The server checks it all. The phone is required
// — its star shown, the field `required` — until a parent or a student of
// the school is picked: the only way back to anyone else (QA, 29/10/2026).
export default class extends Controller {
  static targets = ["kind", "nameLabel", "search", "name", "phone", "phoneRequired", "parentId", "studentId"];
  static values = { labels: Object };

  connect() {
    this.changeKind();
  }

  // The kind chosen: its label on the name, the search for a school member only.
  changeKind() {
    const kind = this.kindTargets.find((radio) => radio.checked)?.value || "person";
    if (this.hasNameLabelTarget && this.labelsValue[kind]) this.nameLabelTarget.textContent = this.labelsValue[kind];
    if (this.hasSearchTarget) this.searchTarget.hidden = kind !== "school_member";
    if (kind !== "school_member") this.forget();
    this.markPhone();
  }

  // A parent or a student picked in the search.
  pick(event) {
    event.preventDefault();
    const { payerName, payerPhone, parentId, studentId } = event.currentTarget.dataset;
    this.nameTarget.value = payerName || "";
    this.phoneTarget.value = payerPhone || "";
    this.parentIdTarget.value = parentId || "";
    this.studentIdTarget.value = studentId || "";
    this.markPhone();
    this.nameTarget.dispatchEvent(new Event("change", { bubbles: true }));
  }

  forget() {
    if (this.hasParentIdTarget) this.parentIdTarget.value = "";
    if (this.hasStudentIdTarget) this.studentIdTarget.value = "";
  }

  markPhone() {
    const picked = (this.hasParentIdTarget && this.parentIdTarget.value) || (this.hasStudentIdTarget && this.studentIdTarget.value);
    if (this.hasPhoneTarget) this.phoneTarget.required = !picked;
    if (this.hasPhoneRequiredTarget) this.phoneRequiredTarget.hidden = Boolean(picked);
  }
}
